import React from 'react';
import { Helmet } from 'react-helmet';
import BlogCard from './BlogCard';
import './BlogPage.css';
import tourist from './image/collage.jpg'
import daultabad from './image/daulatabad.jpg'
import maqbara from './image/maqbara.jpg'
import ellora from './image/ellora.jpg'
import monsoon from './image/monsoon.png'
import airport from './image/airport.png'
import cab from './image/cabs.png'

const BlogPage = () => {
  const trendingTopics = [
    {
      id: 1,
      title: "Top 5 Benefits of Pre-Booking Cabs in Aurangabad",
      excerpt: "Discover why pre-booking your cab in Chhatrapati Sambhaji Nagar can save you time, money, and stress...",
      image: daultabad,
      date: "August 10, 2025",
      readTime: "4 min read",
      category: "Travel Tips"
    },
    {
      id: 2,
      title: "Exploring Aurangabad's Hidden Gems: Best Taxi Routes",
      excerpt: "From Bibi Ka Maqbara to Ellora Caves, find the most scenic and efficient routes for your taxi rides...",
      image: maqbara,
      date: "August 5, 2025",
      readTime: "6 min read",
      category: "Local Guide"
    },
    {
      id: 3,
      title: "How to Get the Best Cab Deals in Sambhaji Nagar",
      excerpt: "Money-saving tips and tricks for getting the most affordable cab rides in Aurangabad...",
      image: ellora,
      date: "July 28, 2025",
      readTime: "5 min read",
      category: "Savings"
    },
    {
      id: 4,
      title: "Monsoon Travel Guide: Safe Taxi Booking in Aurangabad",
      excerpt: "Essential tips for booking cabs during monsoon season in Chhatrapati Sambhaji Nagar...",
      image: monsoon,
      date: "July 20, 2025",
      readTime: "3 min read",
      category: "Seasonal"
    },
    {
      id: 5,
      title: "Airport Taxi Services: Aurangabad to Anywhere",
      excerpt: "Everything you need to know about booking reliable airport taxi services in Aurangabad...",
      image: airport,
      date: "July 15, 2025",
      readTime: "7 min read",
      category: "Airport Services"
    },
    {
      id: 6,
      title: "Why Local Taxi Services Are Thriving in Sambhaji Nagar",
      excerpt: "An in-depth look at how local cab services are transforming transportation in Aurangabad...",
      image: cab,
      date: "July 10, 2025",
      readTime: "8 min read",
      category: "Industry News"
    }
  ];

  return (
    <div className="blog-page">
            <Helmet>
        <title>Taxi & Cab Services Blog - Latest Updates for Chhatrapati Sambhaji Nagar | Aurangabad Cabs</title>
        <meta 
          name="description" 
          content="Stay updated with the latest news, tips, and guides about taxi services in Aurangabad (Chhatrapati Sambhaji Nagar). Get insights on best cab services, booking tips, and urban mobility trends." 
        />
        <meta 
          name="keywords" 
          content="Aurangabad taxi, Chhatrapati Sambhaji Nagar cab, taxi services Aurangabad, book cab online, best taxi Aurangabad, urban mobility, taxi tips, cab booking guide" 
        />
        <meta property="og:title" content="Taxi & Cab Services Blog - Aurangabad Cabs" />
        <meta property="og:description" content="Latest updates and guides about taxi services in Chhatrapati Sambhaji Nagar" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.wahegurucabs.com/blog" />
      </Helmet>
      <section className="blog-hero">
        <div className="hero-content">
          <h1>Trending Taxi & Cab Topics in Chhatrapati Sambhaji Nagar</h1>
          <p>Stay updated with the latest news, tips, and guides for taxi services in Aurangabad</p>
        </div>
      </section>
      
      <section className="featured-topic">
        <div className="container">
          <h2 className="section-title">Featured This Week</h2>
          <div className="featured-card">
            <div className="featured-image">
              <img src={tourist} alt="Featured Topic" />
            </div>
            <div className="featured-content">
              <span className="category-tag featured">Editor's Pick</span>
              <h3>"The Future of Urban Mobility: How Aurangabad is Adapting"</h3>
              <p>An exclusive look at how Chhatrapati Sambhaji Nagar is embracing modern taxi technologies and services to improve urban transportation...</p>
              <button className="read-more-btn">Read Full Article</button>
            </div>
          </div>
        </div>
      </section>
      
      <section className="trending-topics">
        <div className="container">
          <h2 className="section-title">Trending Topics</h2>
          <div className="topics-grid">
            {trendingTopics.map(topic => (
              <BlogCard key={topic.id} topic={topic} />
            ))}
          </div>
        </div>
      </section>
      
      <section className="newsletter">
        <div className="container">
          <h2>Stay Updated with Aurangabad Cab News</h2>
          <p>Subscribe to our newsletter for weekly updates on taxi services, discounts, and travel tips</p>
          <form className="newsletter-form">
            <input type="email" placeholder="Your email address" required />
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </section>
      
    </div>
  );
};

export default BlogPage;